<template>
    <div>
        <router-view :key="indexComponent" @changeIndex="changeIndexComponent"></router-view>
    </div>
</template>

<script>
export default {
  name: 'default-layout',
   data(){
    return{
      indexComponent:1,
    }
  },
  methods:{
    changeIndexComponent(){
      this.indexComponent++;
    }
  }

}
</script>
